<app-kpi-widget
  [title]="'fuelDashboard.widgets.fuelConsumption' | transloco"
  [icon]="icon"
  [isLoading]="isLoading"
  [totalValue]="value"
  [totalCost]="cost"
  [percentageDifference]="percentageDifference"
  [costDifference]="difference"
  [widgetDisabled]="widgetDisabled"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [isUptrendPositive]="isUptrendPositive"
  [dropdownOptions]="dropdownOptions"
  [selectedDropdownValue]="selectedUnit"  
  [costFormatter]="formatCost.bind(this)"
  [valueFormatter]="formatValue.bind(this)"
  [costDifferenceFormatter]="formatCostDifference.bind(this)"
  (clicked)="onWidgetClick()"
  (dropdownChanged)="onDropdownChanged($event)">
</app-kpi-widget>